var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{class:_vm.b(),attrs:{"center":"","title":_vm.title,"border":_vm.border}},[_c('van-switch',_vm._b({on:{"input":function($event){_vm.$emit('input', $event)}}},'van-switch',_vm.$props,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e776fbb0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/jscom/omui/components/switch-cell/index.vue
// module id = aItG
// module chunks = 76